import { BotIcon } from './BotIcon.js';
import styles from './AssistantMark.module.css';

/**
 * The assistant's mark: its glyph, then the dot.
 *
 * It was the dot alone until the unread dot was removed beside it, and on its
 * own an 8px of red at the end of a preview line asked the reader to already
 * know whose mark it was — every other red in an inbox means urgency in
 * general, and this one means something narrower: the assistant read this chat
 * and would have the employer take a decision on it. The glyph is the same one
 * the AssistantCard leads with, so the mark points at the surface where
 * following it pays off.
 *
 * One component rather than a class per site, because it renders in three
 * places — the plain row, a fold's header, and a fold's thread rows — and the
 * pair, in this order at this gap, is the identity. Split across modules, half
 * the sites would drift the day one of them was touched.
 *
 * Scarcity is the whole mechanism: red works here because it is rare, so never
 * wire this to unread or unreplied. Reply debt belongs to the aggregates (the
 * widget launcher, the rail); read/unread speaks in weight.
 */
export function AssistantMark() {
  const label = 'Assistant has a suggestion';
  return (
    <span className={styles.mark} role="img" aria-label={label} title={label}>
      <BotIcon size={13} />
      <span className={styles.dot} />
    </span>
  );
}
